export default __webpack_public_path__ + "static/media/schema_compress.924cf62a.jpg";